import Vue from 'vue';
if (document.getElementById('notifications')) {
    var notifications = new Vue({
        el: '#notifications',
        data: {
            show: true,
            ready: false,
            userId: userId,
            notifications: {
                items: null,
                bell: null,
                interval: null,
            },
            noSeenMore: 5,
            seenMore: 5,
        },
        methods: {
            loadData: function () {
                $.get('/api/v1/notifications', function (response) {
                    this.notifications.items = response;
                    this.ready = true
                }.bind(this));

                this.notifications.bell = !this.isObjectEmpty(this.notifications.items);
            },
            isObjectEmpty: function (Obj) {
                for (var key in Obj) {
                    if (Obj.hasOwnProperty(key))
                        return false;
                }
                return true;
            },
            notionChecked: function (item) {
                var params = {
                    id: item.id
                };
                $.get('/api/v1/notifications/seen', params, function () {
                    item.isSeen = true;
                });

            },
            seenAll: function () {
                var params = {
                    id: this.userId
                };
                $.get('/api/v1/notifications/seen-all', params, function () {
                    notifications.notifications.items.forEach(function (item) {
                        item.isSeen = true;
                    })
                });
            }
        },
        created: function () {
            this.loadData();
            this.notifications.interval = setInterval(function () {
                this.loadData();
            }.bind(this), 15000);
        },
        beforeDestroy: function () {
            clearInterval(this.notifications.interval);
        },
        computed: {
            notifyNoSeen: function () {
                var arr = [];
                for (var index in this.notifications.items) {
                    var item = this.notifications.items[index];
                    if (item.isSeen === false) {
                        arr.push(item)
                    }
                }
                return arr;

            },
            notifySeen: function () {
                var arr = [];
                for (var index in this.notifications.items) {
                    var item = this.notifications.items[index];
                    if (item.isSeen === true) {
                        arr.push(item)
                    }
                }
                return arr;

            },
        }
    });
}